import { Injectable } from '@angular/core';
import { WebGLRenderer } from 'three';

@Injectable()
export class WebGLRendererHelper {
  disposeRenderer(renderer: WebGLRenderer | undefined): void {
    if (!renderer) {
      return;
    }

    if (!this.isWebGLLoseContextSupported(renderer)) {
      return;
    }
    renderer.clear();
    renderer.setRenderTarget(null);
    renderer.domElement = null;
    renderer.forceContextLoss();
    renderer.dispose();
    renderer = null;
  }

  isWebGLLoseContextSupported(renderer: WebGLRenderer): boolean {
    if (!renderer) {
      throw new Error('renderer must not be null or undefined');
    }
    const r = renderer as any;
    const loseContextExtension = r.getContext().getExtension('WEBGL_lose_context');
    return !!loseContextExtension;
  }
}
